var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m149.007 346.637c-4.862-25.388-27.223-44.637-54.007-44.637-30.327 0-55 24.673-55 55s24.673 55 55 55c21.607 0 40.335-12.53 49.324-30.7l111.676-47.974 111.676 47.974c8.989 18.17 27.717 30.7 49.324 30.7 30.327 0 55-24.673 55-55s-24.673-55-55-55c-26.784 0-49.145 19.249-54.007 44.637l-91.993-39.519v-37.118h-30v37.118z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 145,
    r: 35
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191 145c0-35.841 29.159-65 65-65s65 29.159 65 65c0 30.678-21.37 56.442-50 63.234v61.766h105c46.869 0 85-38.131 85-85 0-42.086-30.744-77.126-70.954-83.84-3.607-25.958-17.348-49.859-39.59-68.395-25.355-21.129-58.9-32.765-94.456-32.765s-69.101 11.636-94.456 32.766c-22.242 18.535-35.982 42.437-39.59 68.395-40.21 6.713-70.954 41.753-70.954 83.839 0 46.869 38.131 85 85 85h105v-61.766c-28.63-6.792-50-32.556-50-63.234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.093 414.961c-15.525 16.62-37.609 27.039-62.093 27.039s-46.568-10.419-62.093-27.039c-19.846 13.507-32.907 36.275-32.907 62.039v20c0 8.284 6.716 15 15 15h160c8.284 0 15-6.716 15-15v-20c0-25.764-13.061-48.532-32.907-62.039z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.093 414.961c-15.525 16.62-37.609 27.039-62.093 27.039s-46.568-10.419-62.093-27.039c-19.846 13.507-32.907 36.275-32.907 62.039v20c0 8.284 6.716 15 15 15h160c8.284 0 15-6.716 15-15v-20c0-25.764-13.061-48.532-32.907-62.039z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudAccounts);
export default __webpack_public_path__ + "static/media/cloud-accounts.cddfcc7d593e30e8971d0c7eb3987a24.svg";
export { ForwardRef as ReactComponent };